import CryptoJs from 'crypto-js'
//随机生成指定数量的16进制key
export const generatekey = 'yaolbDcJqlV6rVJPVi2K+e+qGEN6afOK'
// DES(CBC)加密
export const encryptByCBC = function (message, key1, iv1) {
    let key = CryptoJs.enc.Utf8.parse(key1);
    let iv = CryptoJs.enc.Utf8.parse(iv1);
    let srcs = CryptoJs.enc.Utf8.parse(message);
    // 加密模式为CBC，补码方式为PKCS5Padding（也就是PKCS7）
    let encrypted = CryptoJs.TripleDES.encrypt(srcs, key, {
        iv: iv,
        mode: CryptoJs.mode.CBC,
        padding: CryptoJs.pad.Pkcs7
    });
    return CryptoJs.enc.Base64.stringify(encrypted.ciphertext);   //返回base64
}

// DES(CBC)解密
export const decryptByCBC = function (message, key1, iv1) {
    let key = CryptoJs.enc.Utf8.parse(key1);
    let iv = CryptoJs.enc.Utf8.parse(iv1);
    let base64 = CryptoJs.enc.Base64.parse(message);
    let src = CryptoJs.enc.Base64.stringify(base64);
    // 解密模式为CBC，补码方式为PKCS5Padding（也就是PKCS7）
    let decrypt = CryptoJs.TripleDES.decrypt(src, key, {
        iv: iv,
        mode: CryptoJs.mode.CBC,
        padding: CryptoJs.pad.Pkcs7
    });
    let decryptedStr = decrypt.toString(CryptoJs.enc.Utf8);
    return decryptedStr.toString();
}

// DES(ECB)加密
export const encryptByECB = function (message) {
    let key = CryptoJs.enc.Utf8.parse(generatekey);
    let srcs = CryptoJs.enc.Utf8.parse(message);
    // 加密模式为ECB，补码方式为PKCS5Padding（也就是PKCS7）
    let encrypted = CryptoJs.TripleDES.encrypt(srcs, key, {
        mode: CryptoJs.mode.ECB,
        padding: CryptoJs.pad.Pkcs7
    });
    return CryptoJs.enc.Base64.stringify(encrypted.ciphertext);   //返回base64
}

// DES(ECB)解密
export const decryptByECB = function (message) {
    // Log('解密 message', message);
    let key = CryptoJs.enc.Utf8.parse(generatekey);
    let base64 = CryptoJs.enc.Base64.parse(message);
    let src = CryptoJs.enc.Base64.stringify(base64);
    // 解密模式为ECB，补码方式为PKCS5Padding（也就是PKCS7）
    let decrypt = CryptoJs.TripleDES.decrypt(src, key, {
        mode: CryptoJs.mode.ECB,
        padding: CryptoJs.pad.Pkcs7
    });
    let decryptedStr = decrypt.toString(CryptoJs.enc.Utf8);
    return decryptedStr.toString();
}

export function handlerResponseText(xhr) {
    let responseText = xhr
    try {
        return JSON.parse(responseText);
    } catch (e) {
        console.error('首次尝试失败')
    }

    //console.log('text1', responseText)
    responseText = decodeURIComponent(responseText);
    //console.log('text2', responseText)
    responseText = decryptByECB(responseText);
    //console.log('text3', responseText)

    try {
        return JSON.parse(responseText);
    } catch (e) {
        console.error('再次尝试失败')
    }

    return {code: 500, msg: '字符串解码失败'}
}

// const test = encodeURIComponent(encryptByECB('http://192.168.248.32:6684/2020-08-13/200813150003785_19DA6821665207A3.pdf'));
// console.log(test, '===', decryptByECB(decodeURIComponent(test)));
export default {
    encryptByCBC,
    decryptByCBC,
    encryptByECB,
    decryptByECB,
    handlerResponseText
}


